import { useState, useEffect, useRef, useCallback } from 'react'

export default function useMapsSDK() {
  const [state, setState] = useState({ areScriptsReady: false, maps: undefined })
  const mapsScriptElemRef = useRef()

  const onScriptLoad = () => setState({ areScriptsReady: true, maps: window.google.maps })
  const loadMapsScript = useCallback(() => {
    const scriptElem = document.createElement('script')
    scriptElem.type = 'text/javascript'
    scriptElem.id = 'googleMapsSDK'
    scriptElem.src = `https://maps.google.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}`
    mapsScriptElemRef.current = scriptElem

    const randomScriptNode = document.getElementsByTagName('script')[0]
    randomScriptNode.parentNode.insertBefore(scriptElem, randomScriptNode)
    scriptElem.addEventListener('load', onScriptLoad)
  }, [])

  useEffect(() => {
    const mapsSDKScriptNode = document.getElementById('googleMapsSDK')

    if (window.google?.maps) onScriptLoad()
    else if (mapsSDKScriptNode) mapsSDKScriptNode.addEventListener('load', onScriptLoad)
    else if (!mapsSDKScriptNode) loadMapsScript()
  }, [loadMapsScript])

  return state
}
